import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Params } from '@angular/router';
import { Variant, Option, Product } from 'src/app/shop';
import { staticShopSettings } from 'src/app/shop/settings';

@Component({
    selector: 'app-product-variant-options',
    templateUrl: './product-variant-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductVariantOptionsComponent {
  @Input() variants!: Variant[];
  @Input() option!: Option;

  @Input() product!: Product;
  @Input() selectedOptionsFromParams: Params | undefined;

  constructor(private cd: ChangeDetectorRef) {}

  getSelectedOptionValue(optionName: string) {
    return this.selectedOptionsFromParams?.[optionName];
  }

  isAvailable(key: string, value: string) {
    return this.product.variants.some(
      variant => variant.selectedOptions.some(option => option.name === key && option.value === value) && variant.availableForSale
    );
  }

  getOptionAsQueryParam(option: Option, value: string) {
    return { [option.name]: value };
  }

  // klein foutje tijdens product import van Thomas, bugfix om vergeten veld Title te hernoemen...
  variantLabel(label: string) {
    if (label === 'Title') {
      return 'variant';
    }
    return label;
  }
}
